import React from "react";
import { Row, Col } from "react-bootstrap";
import { withTheme } from "styled-components";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import FormattedMessage from "@irati/utils/lang";
import { Label } from "@irati/ui/src/Typography";
import Flex from "@irati/ui/src/Flex";
var UnavailableDeal = function (_a) {
    var isFavouriteDeal = _a.isFavouriteDeal, theme = _a.theme;
    return (React.createElement(Flex, { justifyContent: isFavouriteDeal ? "center" : "flex-start", alignItems: isFavouriteDeal ? "center" : "stretch", minHeight: theme.spacing.eight },
        isFavouriteDeal && (React.createElement(Label, { large: true },
            React.createElement(FormattedMessage, { id: "perks.components.dealBody.unavailableDeal.header" }))),
        !isFavouriteDeal && (React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(Flex, { alignItems: "center" },
                    React.createElement(Icon, { icon: IconTypes.circleDisable, size: 25, color: theme.colors.utility.ink }),
                    React.createElement(Label, { large: true, weight: "bold", marginLeft: true },
                        React.createElement(FormattedMessage, { id: "perks.components.dealBody.unavailableDeal.header" }))))))));
};
export default withTheme(UnavailableDeal);
